import React from "react";
import { Route, BrowserRouter, Switch } from "react-router-dom";
import Home from "../components/Home";
import Login from "../components/Login";
import SignUp from "../components/SignUp";
import Events from "../components/Events";
import Gallery from "../components/Gallery";
import ErrorPage from "../layouts/404";
import Terms from "../layouts/Terms";
import RefundPolicy from "../layouts/RefundPolicy";
import ContactUs from "../layouts/ContactUs";
import PrivacyPolicy from "../layouts/PrivacyPolicy";
import Faq from "../layouts/Faq";
import TeamBuilding from "../layouts/TeamBuilding";
import Games from "../components/Games";
import DownloadApp_QRCode from "../components/DownloadApp_QRCode";
import PaymentPurchase from "../components/cart/PaymentPurchase";
import AddPayConfirmCard from "../components/cart/AddPayConfirmCard";
import AddPaymentContinue from "../components/cart/AddPaymentContinue";
import AddPaymentChooseMethod from "../components/cart/AddPaymentChooseMethod";
import AddYourPaymentMethod from "../components/cart/AddYourPaymentMethod";
import Profile from "../components/Profile";
import MyGames from "../components/MyGames";
import FavoriteGames from "../components/FavoriteGames";
import Cart from "../components/cart/Cart";
import EventPurchase from "../components/EventPurchase";

import AuthRoute from "../components/partials/AuthRoute";
import ProtectedRoute from "../components/partials/ProtectedRoute";
import ForgetPassword from "../components/ForgetPassword";

const Router = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/" component={Home} exact />
      <Route path="/events" component={Events} exact />
      <ProtectedRoute path="/profile" component={Profile} exact />
      <Route path="/cart" component={Cart} exact />
      <Route path="/event-purchase/:id" component={EventPurchase} exact />
      <ProtectedRoute path="/pay-purchase" component={PaymentPurchase} exact />
      <Route path="/ap-confirm-card" component={AddPayConfirmCard} exact />
      <Route path="/ap-continue" component={AddPaymentContinue} exact />
      <Route
        path="/ap-choose-method"
        component={AddPaymentChooseMethod}
        exact
      />
      <Route path="/ap-your-method" component={AddYourPaymentMethod} exact />
      <ProtectedRoute
        path="/download-qr"
        component={DownloadApp_QRCode}
        exact
      />
      <Route path="/games" component={Games} exact />
      <ProtectedRoute path="/my-games" component={MyGames} exact />
      <ProtectedRoute path="/fav-games" component={FavoriteGames} exact />
      <Route path="/gallery" component={Gallery} exact />
      <AuthRoute path="/register" component={SignUp} exact />
      <AuthRoute path="/login" component={Login} exact />
      <AuthRoute path="/forgetpassword" component={ForgetPassword} exact />
      <Route path="/terms" component={Terms} exact />
      <Route path="/refund-policy" component={RefundPolicy} exact />
      <Route path="/team-building" component={TeamBuilding} exact />
      <Route path="/privacy-policy" component={PrivacyPolicy} exact />
      <Route path="/faq" component={Faq} exact />
      <Route path="/contact" component={ContactUs} exact />
      <Route path="*" component={ErrorPage} />
    </Switch>
  </BrowserRouter>
);

export default Router;
